<template>
    <div>
        <h1 class="h5">Verzilver jouw IJSTIJD! code</h1>
        <h2 class="h3">Tik onderstaand de unieke IJSTIJD! code in.</h2>

        <hr>

        <figure class="redeem__image">
            <img
                class="header-home__logo"
                src="@/assets/img/content/polsbandje.png"
                alt="ijstijd">
        </figure>

        <form
            @submit.prevent="preSubmit"
            class="form"
            :class="{'form--loading': loading}">
            <div class="grid-x grid-margin-x grid-margin-y">
                <div class="cell">
                    <input-field
                            v-if="campaign"
                            name="code"
                            label="Voucher code:"
                            :errors="errors"
                            v-model="datamodel.code"
                            v-validate="'required'"
                            placeholder="code"/>
                    <voucher-field
                        v-else
                        name="code"
                        label="Voucher"
                        :errors="errors"
                        v-model="datamodel.code"
                        v-validate="'required'" />
                </div>

                <div class="cell">
                    <div class="btn-holder btn-holder--center">
                        <submit-field>
                            Code verzilveren!
                        </submit-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    inject: ['$validator'],
    props: {
        product: {
            type: Object,
            default: null
        }
    },
    computed: {
        campaign() {
            return this.$route.params.campaign;
        },
    },
    data() {
        return {
            datamodel: {
                code: '',
                id: null,
                type: null,
                campaign: this.$route.params.campaign
            },
            loading: false,
        };
    },
    methods: {
        ...mapActions({
            'orderProduct': 'sportid/order',
            'logout': 'sportid/logout'
        }),
        preSubmit() {
            if(this.loading === true) {
                return;
            }

            this.loading = true;

            this.$nextTick(() => {
                this.submit();
            });
        },
        submit() {
            this.datamodel = Object.assign({}, this.datamodel, {
                type: this.product.type,
                id: (this.product.type === 2) ? this.product.id : this.$route.query.id
            });

            this.orderProduct(this.datamodel).then(() => {
                this.$router.push({
                    name: 'redeem_thanks',
                    params: this.$route.params,
                    query: this.$route.query,
                });
            }, ({data}) => {
                this.loading = false;

                if(data.errors) {
                    Object.entries(data.errors).forEach((item) => {
                        this.errors.add({
                            field: item[0],
                            msg: item[1][0],
                        });
                    });
                } else if(data.message) {
                    this.errors.add({
                        field: 'code',
                        msg: data.message,
                    });
                }
            });
        }
    }
};
</script>
